module.exports = __webpack_public_path__ + "static/media/ADA-BUSD.2f26b25a.png";